/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ValueTuple_List_1_ImportTransferAllocateParseDto } from '../models/ValueTuple_List_1_ImportTransferAllocateParseDto';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class TransferAllocateLegacyService {

    /**
     * @param fileExtension 
     * @param requestBody 
     * @returns ValueTuple_List_1_ImportTransferAllocateParseDto OK
     * @throws ApiError
     */
    public static postApiAwardApiAppTransferAllocateLegacyParseTransferAndAllocate(
fileExtension?: string,
requestBody?: Blob,
): CancelablePromise<ValueTuple_List_1_ImportTransferAllocateParseDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/award/api/app/transfer-allocate-legacy/parse-transfer-and-allocate',
            query: {
                'fileExtension': fileExtension,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

}
